// 商品カードのお気に入りボタン（c-fav-btn）を Wishlist Hero SDK と連携させる
(function () {
  'use strict';

  var wishlistHash = null;

  async function init() {
    var sdk = window.WishListHero_SDK;
    if (!sdk || !sdk.AddWishListItem) {
      console.error('[Wishlist Card] SDK not available');
      return;
    }

    try {
      wishlistHash = await sdk.GetWishListHash(true);
    } catch (err) {
      console.error('[Wishlist Card] GetWishListHash failed:', err);
      return;
    }

    syncActiveState(sdk, false);
    bindClickHandlers(sdk);

    // モーダル内でお気に入りが変更された場合、サーバーから最新状態を取得して再同期
    document.addEventListener('wishlist-items-updated', function () {
      syncActiveState(sdk, true);
    });
  }

  // お気に入り状態を取得して -active クラスを付与/除去
  async function syncActiveState(sdk, fromServer) {
    try {
      var items = fromServer
        ? await sdk.GetWishListItemsFromServer()
        : sdk.GetWishListItems();
      var wishlistProductIds = new Set();
      if (items && items.length > 0) {
        items.forEach(function (item) {
          if (item.ProductId) wishlistProductIds.add(String(item.ProductId));
        });
      }

      var buttons = document.querySelectorAll('.c-fav-btn[data-product-id]');
      buttons.forEach(function (btn) {
        var id = btn.getAttribute('data-product-id');
        btn.classList.toggle('-active', wishlistProductIds.has(id));
      });
    } catch (err) {
      console.error('[Wishlist Card] syncActiveState failed:', err);
    }
  }

  // クリックイベントをイベント委譲で処理
  function bindClickHandlers(sdk) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.c-fav-btn[data-product-id]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.dataset.processing) return;
      btn.dataset.processing = 'true';

      var productId = btn.getAttribute('data-product-id');
      if (!productId) {
        delete btn.dataset.processing;
        return;
      }

      if (btn.classList.contains('-active')) {
        deleteFromWishlist(sdk, btn);
      } else {
        addToWishlist(sdk, btn);
      }
    });
  }

  async function addToWishlist(sdk, btn) {
    try {
      var params = {
        ProductId: Number(btn.getAttribute('data-product-id')),
        ProductVariantId: Number(btn.getAttribute('data-variant-id')),
        ProductTitle: btn.getAttribute('data-product-title'),
        ProductPrice: Number(btn.getAttribute('data-product-price')),
        ProductLink: btn.getAttribute('data-product-url'),
        ProductImage: btn.getAttribute('data-product-image'),
        WishlistHash: wishlistHash,
      };

      var added = await sdk.AddWishListItem(params);
      if (added) {
        syncSameProduct(btn.getAttribute('data-product-id'), true);
        document.dispatchEvent(new CustomEvent('wishlist-count-changed'));
      }
    } catch (err) {
      console.error('[Wishlist Card] addToWishlist failed:', err);
    } finally {
      delete btn.dataset.processing;
    }
  }

  async function deleteFromWishlist(sdk, btn) {
    try {
      var params = {
        ProductVariantId: Number(btn.getAttribute('data-variant-id')),
        WishlistHash: wishlistHash,
      };

      var deleted = await sdk.DeleteWishListItem(params);
      if (deleted) {
        syncSameProduct(btn.getAttribute('data-product-id'), false);
        document.dispatchEvent(new CustomEvent('wishlist-count-changed'));
      }
    } catch (err) {
      console.error('[Wishlist Card] deleteFromWishlist failed:', err);
    } finally {
      delete btn.dataset.processing;
    }
  }

  // 同じ商品IDのボタンすべてのアクティブ状態を同期
  function syncSameProduct(productId, isActive) {
    var buttons = document.querySelectorAll(
      '.c-fav-btn[data-product-id="' + productId + '"]'
    );
    buttons.forEach(function (b) {
      if (isActive) {
        b.classList.add('-active');
      } else {
        b.classList.remove('-active');
      }
    });
  }

  if (window.WishListHero_SDK) {
    init();
  } else {
    document.addEventListener('wishlist-hero-wishlist-sdk-ready', init);
  }
})();
